import styles from "./Components/styles.module.css";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import KeyboardDoubleArrowRightOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import { IconButton, MenuList } from "@mui/material";
import clsx from "clsx";
import VirtualList, { EventDataInfo } from "../../Tools/VirtualList/VirtualList";
import { useContext, useEffect, useRef, useState } from "react";
import { formEdit } from "../../Tools/Tools";
import { SmetaModalsButtonsContext } from "../../Tools/modalManager";
interface ListProps {
  props: {
    sourName: string;
    destName: string;
    sourList: string;
    RequestID?: string;
    func?: any;
    from?: string;
  };
}

interface Item {
  text: string;
  id: string;
}

export default function DialogSelectFromList({ props }: ListProps) {
  const { destName, sourList, sourName, RequestID: requestId, func, from } = props;

  const sourListData = useRef<Array<Item>>([]);
  const destListData = useRef<Array<Item>>([]);
  const sourSelected = useRef<Item>();
  const destSelected = useRef<Item>();

  const [sour, setSour] = useState<Array<Item>>([]);
  const [dest, setDest] = useState<Array<Item>>([]);
  const [sSelected, setSSelected] = useState<Item>();
  const [dSelected, setDSelected] = useState<Item>();

  const setButtons = useContext(SmetaModalsButtonsContext);

  useEffect(() => {
    setButtons?.({
      1: { label: "Выбрать", onClick: onSelect },
    });
  }, [setButtons, destListData.current]);

  const getData = () => {
    return sourList
      .replaceAll('"', "")
      .split(",")
      .map((item, index) => {
        return {
          text: item,
          id: `${index}`,
        };
      });
  };

  useEffect(() => {
    if (sourList) {
      sourListData.current = getData();
      destListData.current = [];

      if (sourListData.current.length) {
        sourSelected.current = sourListData.current[0];
      }

      updateLists();
    }
  }, [sourList]);

  const updateLists = () => {
    setDest([...destListData.current]);
    setSour([...sourListData.current]);
    setSSelected(sourSelected.current);
    setDSelected(destSelected.current);
  };

  const onClickMoveSour = () => {
    let index = 0;
    sourListData.current = sourListData.current.filter((item, id) => {
      if (item.text === sourSelected.current?.text) {
        destListData.current.push(sourSelected.current);
        index = id;
        return false;
      }
      return true;
    });

    if (sourListData.current.length) {
      sourSelected.current = index > 0 ? sourListData.current[index - 1] : sourListData.current[0];
    }

    destListData.current = [...destListData.current];
    updateLists();
  };

  const onClickMoveDest = () => {
    let index = 0;
    destListData.current = destListData.current.filter((item, id) => {
      if (item.text === destSelected.current?.text) {
        sourListData.current.push(destSelected.current);
        index = id;
        return false;
      }
      return true;
    });

    if (destListData.current.length) {
      destSelected.current = index > 0 ? destListData.current[index - 1] : destListData.current[0];
    }

    sourListData.current = [...sourListData.current];
    updateLists();
  };

  const onClickMoveDestAll = () => {
    const oldLength = sourListData.current.length;
    sourListData.current = [...sourListData.current, ...destListData.current];
    destListData.current = [];
    if (sourListData.current.length && oldLength === 0) sourSelected.current = sourListData.current[0];
    updateLists();
  };

  const onClickMoveSourAll = () => {
    const oldLength = destListData.current.length;
    destListData.current = [...destListData.current, ...sourListData.current];
    sourListData.current = [];
    if (destListData.current.length && oldLength === 0) destSelected.current = destListData.current[0];
    updateLists();
  };

  const onSelect = async () => {
    if (requestId)
      await formEdit(
        "1",
        func,
        {
          Name: "Selection",
          Value: destListData.current
            .map((item) => {
              return `"${item.text}"`;
            })
            .join(","),
        },
        requestId,
        from,
      );
  };

  return (
    <div className={clsx(styles.mainDialogBlock)}>
      <div className={clsx(styles.fullDialogFlexContainer)}>
        <div className={clsx(styles.dialogSelectFromListListContainer)}>
          <div className={clsx(styles.dialogSelectFromListListLabel)}>{sourName}</div>
          <div className={clsx(styles.dialogSelectFromListList)}>
            <MenuList
              tabIndex="-1"
              style={{
                height: "calc(100% + 1px)",
                width: "100%",
                outline: "none",
              }}
            >
              <VirtualList
                items={sour}
                selected={sSelected}
                onClick={(data: { text: string; id: string }) => {
                  sourSelected.current = data;
                  setSSelected(sourSelected.current);
                }}
              />
            </MenuList>
          </div>
        </div>
        <div className={clsx(styles.dialogSelectFromListButtonsContainer)}>
          <IconButton onClick={onClickMoveSourAll}>
            <KeyboardDoubleArrowRightOutlinedIcon />
          </IconButton>
          <IconButton onClick={onClickMoveSour}>
            <KeyboardArrowRightOutlinedIcon />
          </IconButton>
          <IconButton onClick={onClickMoveDest}>
            <KeyboardArrowLeftOutlinedIcon />
          </IconButton>
          <IconButton onClick={onClickMoveDestAll}>
            <KeyboardDoubleArrowLeftOutlinedIcon />
          </IconButton>
        </div>
        <div className={clsx(styles.dialogSelectFromListListContainer)}>
          <div className={clsx(styles.dialogSelectFromListListLabel)}>{destName}</div>
          <div className={clsx(styles.dialogSelectFromListList)}>
            <MenuList
              tabIndex="-1"
              style={{
                height: "calc(100% + 1px)",
                width: "100%",
                outline: "none",
              }}
            >
              <VirtualList
                items={dest}
                selected={dSelected}
                onClick={(data: { text: string; id: string }) => {
                  destSelected.current = data;
                  setDSelected(destSelected.current);
                }}
              />
            </MenuList>
          </div>
        </div>
      </div>
    </div>
  );
}
